import { gql } from '@apollo/client';
import Fragments from '../fragments';

export const COUNTRIES_QUERY = gql`
  query getCountries {
    countries {
      id
      name
      code
    }
  }
`;

export const CITIES_QUERY = gql`
  query filterCities($query: String!) {
    filterCities(query: $query) {
      id
      name
      country {
        id
        name
      }
    }
  }
`;

export const DOMAINS_QUERY = gql`
  query getDomains {
    domains {
      id
      name
      slug
      created_at
      subdomains {
        id
        name
        slug
        created_at
      }
    }
  }
`;

export const OPPORTUNITY_METADATA_QUERY = gql`
  query getMeta {
    domains {
      id
      name
      slug
      created_at
      subdomains {
        id
        name
        slug
        created_at
      }
    }
    countries {
      id
      name
      code
    }
    languages {
      id
      name
      slug
      created_at
      is_supported
    }
    myOrganisations {
      id
      slug
      name
      logo {
        name
        path
        thumb
      }
    }
    eventTypes {
      id
      name
      slug
    }
    myTracks {
      id
      track_name
      track_admin
      track_description
      slug
    }
  }
`;

export const OPPORTUNITY_UNAUTH_METADATA_QUERY = gql`
  query getMeta {
    domains {
      id
      name
      slug
      created_at
      subdomains {
        id
        name
        slug
        created_at
      }
    }
    countries {
      id
      name
      code
    }
    eventTypes(orderBy: { column: SLUG, order: ASC }) {
      id
      name
      slug
    }
  }
`;

export const FORM_SECTIONS_QUERY = gql`
  query ($target: TargetUser!) {
    formSections(target: $target) {
      name
      slug
      fields {
        id
        name
        is_custom
        type
        ... on BuilderField {
          is_required
        }
        ... on SelectField {
          is_multiple
          choices
        }
        ... on TextField {
          minLength
          maxLength
        }

        ... on RemoteSelectField {
          is_multiple
        }
        ... on FileField {
          size
          count
          accept
        }
        ... on LinkField {
          preview_source
        }
      }
    }
  }
`;

export const FORM_SECTIONS_CACHED_QUERY = gql`
  query ($target: TargetUser!) {
    formSections(target: $target) @client {
      name
      slug
      #     target
      fields {
        id
        name
        is_custom
        type
        ... on SelectField {
          is_multiple
          choices
        }
        ... on TextField {
          minLength
          maxLength
        }

        ... on RemoteSelectField {
          is_multiple
        }
        ... on FileField {
          size
          count
          accept
        }
        ... on LinkField {
          preview_source
        }
      }
    }
  }
`;

export const ORGAINSATION_ACCOUNT_QUERY = gql`
  query ($organisation: ID!) {
    organisationAccount(organisation: $organisation) {
      id
      name
      email
      default_currency
      charges_enabled
      payouts_enabled
      organisations {
        id
      }
      created_at
    }
  }
`;

export const PAYMENT_COUNTRIES = gql`
  query {
    paymentCountries {
      ...countriesInfo
    }
  }
  ${Fragments.countriesInfo}
`;

export const SCIENTIST_METADATA_QUERY = gql`
  query ScientistMetadata($input: ScientistFilterInput, $first: Int!) {
    scientistSearch(first: $first) {
      data {
        id
        name
        email
        profile_image {
          name
        }
        location {
          formatted_address
        }
        university
        research_interests
      }
    }
  }
`;
